import GlobalConst from "../constants/GlobalConst";
import * as SportsConst from "../constants/SportsConst";

export const getTeamShortName = (teamId, statsType) => {
    switch(statsType){
        case 'NHLPlayer' :
            return SportsConst.NHLTeams[teamId]?.key;
        case 'NBAPlayer' :
            return SportsConst.NBATeams[teamId]?.key;
        case 'NFLPlayer' :
            return SportsConst.NFLTeams[teamId]?.key;
        case 'MLBPlayer' :
            return SportsConst.MLBTeams[teamId]?.key;
        case 'SOCCERPlayer' :
            return SportsConst.SoccerTeams[teamId]?.key;
        default:
            return null;
    }
}

export const getTeamLogoUrl = (league, teamId, statsType, teamKey, isInternational = false) => {
    switch((league || "").toUpperCase()){
        case 'NHL':
            return `${GlobalConst.CDN.BASEURL}images/Teams/NHL/${teamKey}.png`;
        case 'NBA':
            return `${GlobalConst.CDN.BASEURL}images/Teams/NBA/${teamKey}.png`;
        case 'MLB':
            return `${GlobalConst.CDN.BASEURL}images/Teams/MLB/${teamKey}.png`;
        case 'NFL':
            return `${GlobalConst.CDN.BASEURL}images/Teams/NFL/${teamKey}.png`;
        case 'GOLF':
            return `${GlobalConst.CDN.BASEURL}images/Teams/GOLF/${teamKey}.jpg`;
        case 'SOCCER':
            return `${GlobalConst.CDN.BASEURL}images/Teams/SOCCER/${teamId}.svg`;
        default:
            return '';
    }
}

export const getLeagueByTeamId = (teamId) => {
    if (SportsConst.NHLTeams.hasOwnProperty(teamId)) {
        return 'NHL';
    } else if (SportsConst.NBATeams.hasOwnProperty(teamId)) {
        return 'NBA';
    } else if (SportsConst.NFLTeams.hasOwnProperty(teamId)) {
        return 'NFL';
    } else if (SportsConst.MLBTeams.hasOwnProperty(teamId)) {
        return 'MLB';
    } else if (SportsConst.SoccerTeams.hasOwnProperty(teamId)) {
        return 'Soccer';
    }
    return null;
};

export const getLeagueBySportId = (parlayName,sportId) => {
    if( sportId !== 3){
        return GlobalConst.LEAGUES_BY_SPORT_ID[sportId];
    }else{
        return parlayName.split(' ')[0];
    }
}